<template>
    <div class="lc_slides TQ_center TQ_height_350px TQ_width_200px TQ_text_14px" id="main" >

        <div class="TQ_margin_16px lc_slide" :ref="'slide' + index_n" v-for="(imgUrl_s, index_n) in p_imagesUrl_as">
            <div v-if="p_imagesTitle_a_blc_s[index_n]">{{p_imagesTitle_a_blc_s[index_n][p_system_langCode_e]}}</div>
            <img :src="imgUrl_s" class="TQ_maxWidth_150px TQ_border TQ_borderRadius" />
        </div>

    </div>
</template>

<script>
    import {date_doEveryClockTick_addCb_f, date_doEveryClockTick_removeCb_f} from "../../scripts/S_Date";
    import {validator_enum_fb} from "../../../functions/src/shareCode/Share_S_Validator";
    import {enum_langCodes} from "../../../functions/src/shareCode/Share_S_Enum";

    export default {
        name: "TqImagesCarousel",
        props:{
            p_imagesUrl_as:{
                require: true,
                type: Array,
            },
            p_imagesTitle_a_blc_s:{
                type: Array,
                default(){
                    return []
                }
            },
            p_system_langCode_e:{
                type: String,
                require: true,
                validator(langCode){
                    return validator_enum_fb(enum_langCodes, langCode)
                }
            },
            p_translateX_n:{
                default: 150
            },
            p_scale_n:{
                default: 0.2
            },
            p_initScale:{
                default: 1.3
            },
            p_animationEverySeconds_n:{
                default: 4
            }
        },
        data(){
            return  {
                currentIndex_n : 0,
                cardsNum_n : this.p_imagesUrl_as.length,
                centerIndex_n : Math.floor(this.p_imagesUrl_as.length/2)
            }
        },
        methods:{
            m_slideQuestType_f(){

                for(let index=0; index<this.cardsNum_n; index++){

                    let translateX;
                    let scale_n;
                    let zIndex_n;
                    if(this.centerIndex_n < index){
                        let multipleBy_n = this.cardsNum_n - index

                        translateX = this.p_translateX_n * -multipleBy_n;
                        scale_n = this.p_initScale-this.p_scale_n * multipleBy_n
                        zIndex_n = this.cardsNum_n - multipleBy_n
                    }else{
                        translateX = this.p_translateX_n * index
                        scale_n = this.p_initScale-this.p_scale_n*index
                        zIndex_n = this.cardsNum_n - index
                    }

                    this.$refs['slide' + ((this.currentIndex_n + index) % this.cardsNum_n)][0].style.zIndex     = zIndex_n
                    this.$refs['slide' + ((this.currentIndex_n + index) % this.cardsNum_n)][0].style.transform  = `translateX(${translateX}px) scale(${scale_n})`
                }

            },
        },
        mounted(){
            let ticks_n = 0

            date_doEveryClockTick_addCb_f(this.$options.name, () => {

                ticks_n++

                // quests type
                if(ticks_n % this.p_animationEverySeconds_n === 0){
                    this.currentIndex_n++
                    if(this.currentIndex_n === this.cardsNum_n){this.currentIndex_n=0}
                    this.m_slideQuestType_f()
                }


            }, true)
        },
        destroyed(){
            date_doEveryClockTick_removeCb_f(this.$options.name)
        }
    }
</script>

<style scoped lang="scss">
    .lc_slides{
        position: relative;

        .lc_slide{
            position: absolute;
            transition: all .5s;
        }


    }
</style>